export default __webpack_public_path__ + "static/media/movie.95f0da47.mp4";